import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss']
})
export class MainFooterComponent implements OnInit {
  sections = [
    { title: 'Termeni și condiții', slug: 'privacy-policy' },
    { title: 'Contact', slug: 'contact' },
  ];
  currentSection: string;
  private routerSubscription: Subscription;
  shouldHide: boolean;
  private SECTIONS_WHERE_TO_HIDE = ['online-games'];

  constructor(private router: Router) {
    this.routerSubscription = this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.currentSection = this.router.url.split('/')[1];
          this.shouldHide = this.SECTIONS_WHERE_TO_HIDE.includes(this.currentSection);
        }
      });
  }

  ngOnInit(): void {
  }

}
